<template>
  <div id="app">
    <div class="class-head" id="class-head">
      <div class="x-f">
        <img alt="logo" src="./assets/image/1.png" style="width: 40px;height: 40px;">
        <div class="f-4 f-24 ml20" style="font-weight: bold;">朝运</div>
        <div class="f-4 f-14 ml20 title">专注本地生活领域</div>
      </div>
      <div class="right-btn">
        <div class="x-f" style="justify-content: end;">
          <el-button type="text" class="btn f-14"><a href="#index">首页</a></el-button>
          <el-button type="text" class="btn f-14"><a href="#jianjie">公司简介</a></el-button>
          <el-button type="text" class="btn f-14"><a href="#yugao">产品预告</a></el-button>
          <el-button type="text" class="btn f-14"><a href="#anli">案例</a></el-button>
          <el-button @click="handClick" style="padding: 6px 10px;color: #5d56ed;">立即体验</el-button>
        </div>
      </div>
      <!-- <div class="right-except">
          <i class="el-icon-s-fold" style="color: #fff;font-size: 24px;" @click="handOpen"></i>
        </div> -->
    </div>
    <div class="class-bannerSection" id="index">
      <div class="bannerSection">
        <div>
          <div class="title-1" style="font-weight: bold;letter-spacing: 6px;">朝运科技</div>
          <div class="title-2 f-14">
            <div>同城本地生活，涵盖团购到店/堂食点单/线上外卖/会员营销/新客裂变/</div>
            <div>老客营销/私域CRM等本地生活解决方案</div>
          </div>
          <el-button @click="handClick" style="padding: 6px 10px;color: #409eff;margin-top: 30px;">了解更多</el-button>
        </div>
        <div>
          <img alt="logo" src="./assets/image/2.png" class="image">
        </div>
      </div>
    </div>
    <div class="class-characteristic" id="jianjie">
      <div class="characteristic-box">
        <img src="./assets/image/3.png" class="image">
        <div class="characteristic-box-padding">
          <div class='characteristic-box-1'>
            <div class="x-f">
              <img src="./assets/image/characteristic-1.png" class="characteristic-box-image" />
              <div class="ml20">
                <div class="characteristic-box-title-1">技术产品有保障</div>
                <div class="characteristic-box-title-2">每个产品由20+技术全权保障</div>
              </div>
            </div>
          </div>
        </div>
        <div class="characteristic-box-padding">
          <div class='characteristic-box-2'>
            <div class="x-f">
              <img src="./assets/image/characteristic-2.png" class="characteristic-box-image" />
              <div class="ml20">
                <div class="characteristic-box-title-1">产品性能更强大，私有数据更安全</div>
                <div class="characteristic-box-title-2">每年服务器成本超30w，只为性能到极致，数据更安全</div>
              </div>
            </div>
          </div>
        </div>
        <div class="characteristic-box-padding">
          <div class='characteristic-box-3'>
            <div class="x-f">
              <img src="./assets/image/characteristic-3.png" class="characteristic-box-image" />
              <div class="ml20">
                <div class="characteristic-box-title-1">全民开发，注重每一个客户</div>
                <div class="characteristic-box-title-2">不断搜集客户需求，使每一个客户都能稳定落地运营</div>
              </div>
            </div>
          </div>
        </div>
        <div class="characteristic-box-padding">
          <div class='characteristic-box-4'>
            <div class="characteristic-order">
              <img src="./assets/image/characteristic-4.png" class="characteristic-box-image" />
              <div class="mr20" style="text-align: right;">
                <div class="characteristic-box-title-1">专属售后更贴心</div>
                <div class="characteristic-box-title-2">一对一专属售后运营无忧</div>
              </div>
            </div>
          </div>
        </div>
        <div class="characteristic-box-padding">
          <div class='characteristic-box-5'>
            <div class="characteristic-order">
              <img src="./assets/image/characteristic-5.png" class="characteristic-box-image" />
              <div class="mr20">
                <div class="characteristic-box-title-1">用户选择，值得信赖</div>
                <div class="characteristic-box-title-2" style="text-align: right;">
                  <div>全国合作公司达1000+</div>
                  <div>合作商户达3w+</div>
                  <div>覆盖全国200+城市</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="class-container">
      <div class="class-container-tittle-1">芜湖朝运网络科技有限公司</div>
      <div class="class-container-tittle-2" style="margin-top: 20px;margin-bottom: 40px;">专注本地生活解决方案·因专注即更专业</div>
      <div class="class-container-box">
        <!-- <div v-for="item,index in containerData" :key="index">
              <div :class="(index+1)==4?'class-container-content-4':(index+1)==5?'class-container-content-5':'class-container-content'">
                <img :src="item.url" class="image" />
                <div class="class-container-content-title-1">{{item.title1}}</div>
                <div class="class-container-content-title-2">{{item.title2}}</div>
              </div>
            </div> -->
        <div class="class-container-content icon-box-1" v-on:mouseenter="hoverON(1)" @mouseleave="hoverOut(1)">
          <img src="./assets/image/container-1.png" class="image"
            :style="iconPathHover[1] ? 'opacity:1' : 'opacity:0;width:0'" />
          <img src="./assets/image/container-1-v.png" class="image"
            :style="iconPathHover[1] ? 'opacity:0;width:0' : 'opacity:1'" />
          <div class="class-container-content-title-1">多线方案</div>
          <div class="class-container-content-title-2">堂食点单、线上外卖、到店团购等多种 解决方案满足单店各种需求</div>
        </div>
        <div class="class-container-content" v-on:mouseenter="hoverON(2)" @mouseleave="hoverOut(2)">
          <img src="./assets/image/container-2.png" class="image"
            :style="iconPathHover[2] ? 'opacity:1' : 'opacity:0;width:0'" />
          <img src="./assets/image/container-2-v.png" class="image"
            :style="iconPathHover[2] ? 'opacity:0;width:0' : 'opacity:1'" />
          <div class="class-container-content-title-1">精准营销</div>
          <div class="class-container-content-title-2">优惠券、会员卡、免单、抽奖等多种 营销功能使其精准营销</div>
        </div>
        <div class="class-container-content" v-on:mouseenter="hoverON(3)" @mouseleave="hoverOut(3)">
          <img src="./assets/image/container-3.png" class="image"
            :style="iconPathHover[3] ? 'opacity:1' : 'opacity:0;width:0'" />
          <img src="./assets/image/container-3-v.png" class="image"
            :style="iconPathHover[3] ? 'opacity:0;width:0' : 'opacity:1'" />
          <div class="class-container-content-title-1">多渠道端口</div>
          <div class="class-container-content-title-2">微信小程序、公众号、H5、APP、抖音 小程序、快手小程序、支付宝小程序等</div>
        </div>
        <div class="class-container-content-4" v-on:mouseenter="hoverON(4)" @mouseleave="hoverOut(4)">
          <img src="./assets/image/container-4.png" class="image"
            :style="iconPathHover[4] ? 'opacity:1' : 'opacity:0;width:0'" />
          <img src="./assets/image/container-4-v.png" class="image"
            :style="iconPathHover[4] ? 'opacity:0;width:0' : 'opacity:1'" />
          <div class="class-container-content-title-1">可OEM贴牌</div>
          <div class="class-container-content-title-2">可根据用户需求特定系统名称、平台名称、版权信息等</div>
        </div>
        <div class="class-container-content-5" v-on:mouseenter="hoverON(5)" @mouseleave="hoverOut(5)">
          <img src="./assets/image/container-5.png" class="image"
            :style="iconPathHover[5] ? 'opacity:1' : 'opacity:0;width:0'" />
          <img src="./assets/image/container-5-v.png" class="image"
            :style="iconPathHover[5] ? 'opacity:0;width:0' : 'opacity:1'" />
          <div class="class-container-content-title-1">可私有化部署</div>
          <div class="class-container-content-title-2">独立部署，服务器、数据独立，私有化更高</div>
        </div>
      </div>
    </div>
    <div class="class-carousel" id="yugao">
      <div class="class-carousel-title-1">产品预告</div>
      <div class="class-carousel-title-2">美仔本地生活系统 <span class="class-carousel-title-span">地方性团购、异业外卖、堂食点单等</span>
      </div>
      <div class="class-carousel-el">
        <el-carousel :interval="5000" arrow="always" :autoplay="false">
          <el-carousel-item v-for="item, index in carouselData" :key="index" autoplay="false">
            <div class="class-carousel-box">
                <img src="./assets/image/iphone.png" class="image" />
                <div class="image-show-box">
                  <img :src="item.url" class="image-show" />
                </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="class-cooperationcases" id="anli" style="padding-top: 80px;">
      <div class="class-cooperationcases-title">抖音本地生活深耕ISV合作案例</div>
      <div class="class-cooperationcases-box">
        <div v-for="item, index in cooperationcasesData" :key="index">
          <div class="class-cooperationcases-box-1">
            <div class="class-cooperationcases-content">
              <img :src="item.url" class="image">
              <div class="class-cooperationcases-box-title-1">{{ item.title1 }}</div>
              <div class="class-cooperationcases-box-title-2">{{ item.title2 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="class-merchantlist">
      <div class="class-merchantlist-title">抖音商户案例</div>
      <div class="class-merchantlist-box">
        <div  class="class-merchantlist-item">
          <el-carousel height="440px">
            <el-carousel-item v-for="(item, index) in merchantList" :key="index">
              <div class="x-bc">
                <img :src="item.url1" class="image"/>
                <img :src="item.url2" class="image"/>
                <img :src="item.url3" class="image"/>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- <el-scrollbar style="width: 100%;height: 494px;position: relative;" wrap-style="overflow-x:hidden;"
          ref="elbar1">
          <div class="x-f">
            <div v-for="item, index in merchantList" :key="index">
              <img :src="item.url" class="image" />
            </div>
          </div>
        </el-scrollbar> -->
      </div>

    </div>
    <!-- <div class="class-productPreview">
      <div class="class-productPreview-title-1">产品预览<span class="class-productPreview-title-span">仅展示部分</span></div>
      <div class="class-productPreview-title-2">其中包括我司参与研发朝运抖音ISV本地生活系统/红利免单城市社交电商/零点城市/社交电商/智慧城市社交电商/旺店助手等诸多产品</div>
      <img src="./assets/image/productPreview.png" class="image" />
    </div> -->

    <div class="class-footing">
      <div class="class-footing-content">
        <div style="border-bottom: 1px solid #252525;display: flex;align-items: center;justify-content: space-between;padding-bottom: 30px;">
          <div v-for="item, index in footingData" :key="index">
          <div class="x-f">
            <img :src="item.url" class="image">
            <div style="margin-left: 20px;">
              <div class="class-footing-content-title-1">{{ item.title1 }}</div>
              <div class="class-footing-content-title-2">{{ item.title2 }}</div>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div class="class-footing-support" style="border-bottom: 1px solid #252525;">
        <div class="class-footing-support-3">
          <div class="class-footing-support-title">服务与支持</div>
          <div class="mt10 class-footing-support-title-1">7*24小时售后</div>
          <div class="class-footing-support-title-1">本地生活多线解决方案</div>
          <div class="class-footing-support-title-1">全线讲解</div>
        </div>
        <div class="class-footing-support-3">
          <div class="class-footing-support-title">资质认证</div>
          <div class="mt10 class-footing-support-title-1">ICP备案</div>
          <div class="class-footing-support-title-1">双软认证</div>
          <div class="class-footing-support-title-1">信息安全等级保护</div>
        </div>
        <div class="class-footing-support-3">
          <div class="class-footing-support-title">联系我们</div>
          <div class="mt10" style="display: flex;align-items: center;">
            <img src="./assets/image/weizhi.png" style="width: 14px;height: auto;margin-top: 10px;transform: translateY(2px);" />
            <div class="class-footing-support-title-1 ml10">成都高新区新雅东街</div>
          </div>
          <div style="display: flex;align-items: center;">
            <img src="./assets/image/wangzhi.png" style="width: 14px;height: auto;margin-top: 10px;transform: translateY(1px);" />
            <div class="class-footing-support-title-1 ml10">
              https://www.meizailife.com/</div>
          </div>
        </div>
        <div class="class-footing-support-image" style="padding: 10px;border-radius: 10px;background-color: #fff;">
          <img src="./assets/image/kegu.png" style="width: 100px;height: 100px;">
        </div>
      </div>
      <div class="class-copyright">
        四川朝运科技有限公司 版权所有copyright@2024-2032 备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color:#5d56ed;text-decoration: underline;">蜀ICP备2024057897号</a>
        <div class="mt20"></div>
      </div>
    </div>
    <el-backtop :bottom="200" class="class-backtop">
      <div class="class-backtop-show">
        <div class="backtop">在线客服</div>
        <div class="backtop-title" style="border-bottom: 1px solid #efefef;margin-bottom:6px ;">
          <div>微信咨询</div>
          <img src="./assets/image/kegu.png" class="image">
          <div style="margin:20px 0 10px 0;">
            <img src="./assets/image/backtop.png" class="backtop-image" style="transform: translateY(2px);">
            返回顶部
          </div>
        </div>
      </div>
      <div class="class-backtop-top">
        <i class="el-icon-arrow-up"></i>
      </div>

    </el-backtop>
    <!-- <el-drawer title="我是标题" :visible.sync="drawer" :direction="direction" :before-close="handleClose">
      <span>我来啦!</span>
    </el-drawer> -->
    <el-dialog width="400px" title="" :visible.sync="directconnection" :append-to-body="true"
      @close="directconnectionclose">
      <div style="text-align: center;" class="dialog-title">
        <div>你好，我是你的专属客服</div>
        <img src="./assets/image/kegu.png" alt="" style="width:198px;height: 198px;margin-top: 20px;">
        <p>了解免费试用，欢迎添加客服企业微信，</p>
        <p>在使用的过程中遇到任何问题我都会帮你解决。</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
window.addEventListener('scroll', function () {
  var header = document.querySelector('#class-head');
  var sticky = header.offsetTop;
  if (sticky > 100) {
    header.classList.add('sticky-change');
  } else {
    header.classList.remove('sticky-change');
  }
});
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      iconPathHover: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
      },
      drawer: false,
      directconnection: false,
      timer: null,
      direction: 'ltr',
      carouselData: [
        {
          url: require('./assets/image/iponeShow/1.png'),
        },
        {
          url: require('./assets/image/iponeShow/2.png'),
        },
        {
          url: require('./assets/image/iponeShow/3.png'),
        },
        {
          url: require('./assets/image/iponeShow/4.png'),
        },
        {
          url: require('./assets/image/iponeShow/5.png'),
        }
      ],
      merchantList: [
        {
          url1: require('./assets/image/poi/1.jpg'),
          url2: require('./assets/image/poi/2.jpg'),
          url3: require('./assets/image/poi/3.jpg')
        },
        {
          url1: require('./assets/image/poi/4.jpg'),
          url2: require('./assets/image/poi/5.jpg'),
          url3: require('./assets/image/poi/6.jpg')
        },
        {
          url1: require('./assets/image/poi/7.jpg'),
          url2: require('./assets/image/poi/8.jpg'),
          url3: require('./assets/image/poi/9.jpg'),
        },
        {
          url1: require('./assets/image/poi/10.jpg'),
          url2: require('./assets/image/poi/11.jpg'),
          url3: require('./assets/image/poi/12.jpg')
        },
        {
          url1: require('./assets/image/poi/13.jpg'),
          url2: require('./assets/image/poi/14.jpg'),
          url3: require('./assets/image/poi/15.jpg')
        },
        {
          url1: require('./assets/image/poi/16.jpg'),
          url2: require('./assets/image/poi/17.jpg'),
          url3: require('./assets/image/poi/18.jpg')
        },
        {
          url1: require('./assets/image/poi/19.jpg'),
          url2: require('./assets/image/poi/20.jpg'),
          url3: require('./assets/image/poi/21.jpg')
        },
        {
          url1: require('./assets/image/poi/22.jpg'),
          url2: require('./assets/image/poi/23.jpg'),
          url3: require('./assets/image/poi/24.jpg')
        },
        {
          url1: require('./assets/image/poi/25.jpg'),
          url2: require('./assets/image/poi/26.jpg'),
          url3: require('./assets/image/poi/27.jpg')
        },
        {
          url1: require('./assets/image/poi/28.jpg'),
          url2: require('./assets/image/poi/29.jpg'),
          url3: require('./assets/image/poi/30.jpg')
        },
        {
          url1: require('./assets/image/poi/31.jpg'),
          url2: require('./assets/image/poi/32.jpg'),
          url3: require('./assets/image/poi/1.jpg'),
        }
      ],
      footingData: [
        {
          url: require('./assets/image/gengxin1.png'),
          title1: '持续迭代更新',
          title2: '公司成立以来持续更新',
        },
        {
          url: require('./assets/image/gengxin2.png'),
          title1: '运营资料持续输出',
          title2: '持续直播/电子版运营讲解',
        },
        {
          url: require('./assets/image/gengxin3.png'),
          title1: '7X24小时售后服务',
          title2: '一对一售后，运营管理更流畅',
        }
      ],
      cooperationcasesData: [
        {
          url: require('./assets/image/jun.png'),
          title1: '朝运',
          title2: '2021年入驻抖音ISV服务商，首批抖音小程序团购服务商单方助力抖音拉新餐饮商户10w+；2024年作为首批抖音小程序外卖服务商，外卖NKA商户突破1000+，CKA商户突破4000+。',
        },
        {
          url: require('./assets/image/meishida.png'),
          title1: '美食达',
          title2: '2021年入驻抖音ISV服务商，与我司达成合作我司协助其研发抖音本地生活第三方平台，上线首月GMV突破2000w；23年9月抖音官方特批第一个小程序外卖闭环链路ISV服务商，在24年3月外卖单店商户突破10w+，GMV突破8000w。',
        },
        {
          url: require('./assets/image/tiantianshenghuo.png'),
          title1: '天天生活',
          title2: '2024年6月与我司达成战略合作，我司协助天天生活入驻抖音外卖ISV服务商，8月新版抖音外卖第三方系统正式上线，至2024年12月短短4个月，平台下第三方服务商已突破8000+，商户以突破10w+，GMV成功突破6000w。',
        },
      ],
      containerData: [
        {
          url: require('./assets/image/container-1.png'),
          title1: '多线方案',
          title2: '堂食点单、线上外卖、到店团购等多种 解决方案满足单店各种需求',
        },
        {
          url: require('./assets/image/container-2.png'),
          title1: '精准营销',
          title2: '优惠券、会员卡、免单、抽奖等多种 营销功能使其精准营销'
        },
        {
          url: require('./assets/image/container-3.png'),
          title1: '多渠道端口',
          title2: '微信小程序、公众号、H5、APP、抖音 小程序、快手小程序、支付宝小程序等'
        },
        {
          url: require('./assets/image/container-4.png'),
          title1: '可OEM贴牌',
          title2: '可根据用户需求特定系统名称、平台名称、版权信息等'
        },
        {
          url: require('./assets/image/container-5.png'),
          title1: '可私有化部署',
          title2: '独立部署，服务器、数据独立，私有化更高'
        }
      ]
    }
  },
  mounted() {
    // setTimeout(() => {
    //   this.handRightSelecOpen()
    // }, 1000)
  },
  methods: {
    hoverON(key) {
      this.iconPathHover[key] = true
    },
    hoverOut(key) {
      this.iconPathHover[key] = false
    },
    directconnectionclose() {
      this.directconnection = false
    },
    handClick() {
      this.directconnection = true
    },
    handOpen() {
      this.drawer = true
    },
    handRightSelecOpen() {
      console.log('发的顺丰快件但是', this.$refs['elbar1']);
      if (!this.$refs['elbar1']) {
        return
      }
      // 保存滚动盒子左侧已滚动的距离
      let left = this.$refs['elbar1'].wrap.scrollLeft
      // 保存元素的整体宽度
      let scrollWidth = this.$refs['elbar1'].wrap.scrollWidth
      // 保存元素的可见宽度
      let clientWidth = this.$refs['elbar1'].wrap.clientWidth
      let num = 0
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        // 已经滚动距离+可见宽度
        // left+clientWidth>=scrollWidth：滚动到最右侧
        // num>=120000一次性滚动距离
        if (left + clientWidth >= scrollWidth || num >= 120000) {
          this.is_SlideLeft = true
          clearInterval(this.timer)
          return
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs['elbar1'].wrap.scrollLeft = left += 10
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num += 10
      }, 200)
    },
    handleClose(done) {
      done()
    }
  }
}
</script>
<style>
.dialog-title {
  font-size: 16px;
  font-weight: 500;
  color: #3b426b;
}

.head {
  height: 80px;
  background: #342CE9;
}

.btn {
  margin-right: 40px;
  font-size: 16px;
}

.btn:hover {
  font-weight: bold;
  font-size: 16px;
  color: #FFFFFF;
  border-bottom: 2px solid #fff;
  border-radius: 0;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
  text-align: left;
  padding: 10px 0;
}

.bg-purple {
  background-color: transparent
}
</style>